import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import axios from 'axios';
import Vue from 'vue';

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    device_types: ['app', 'mobile', 'desktop'],
    publisher: null,
    selectedPublisher: [],
    sites: [],
    selectedSite: null,
    selectedType: null,
    siteDetails: null,      //current
    siteDetailsTabs: [
        {name: 'Allgemeines', component: 'General'},
        {name: 'Ad-Server', component: 'AdServer'},
        {name: 'Zonen', component: 'Zones'},
        {name: 'Local.js', component: 'LocalJs'},
        {name: 'Local.css', component: 'LocalCss'},
        {name: 'Module', component: 'Modules'},
        {name: 'Domains', component: 'Domains'},
        {name: 'AdTag Rendering', component: 'AdTagRendering'},
        {name: 'History', component: 'History'},
        {name: 'Notizen', component: 'Notes'},
        {name: 'Blockieren', component: 'Blocking'},
        {name: 'Includes', component: 'Includes'}],
    selectedModule: null,
    moduleDetails: null,        //current
    siteUpdate: 0,              //watch this for "succesfully added Site" event
    sitetypeUpdate: 0,          //watch this for "succesfully added Sitetype" event
    ignoreSiteUpdate: false,
    ignoreTypeUpdate: false,
    loadingPublisher: false,
    loadingSites: false,
    loadingSite: false,
    loadingSitetype: false,
    siteCancelToken: null,
    sitetypeCancelToken: null,
    detailsContentMinHeight: 500,
    previousTab: null,
    activeTab: 'General',
    relPaths: ['MoltenBundle.top.js', 'MoltenBundle.bottom.js', 'MoltenBundle.js']
};

// getters
const getters = {
    sites() {
        let ret = [];
        if (state.sites) {
            state.sites.forEach((site) => {
                let sitesPublisher = state.publisher.find(x => x.PublisherId === site.PublisherId);
                if (state.selectedPublisher.includes(sitesPublisher)) {
                    ret.push({name: site.Name, group: sitesPublisher.Name});
                }
            })
        }
        return ret;
    },
    //for better reactivity(computed property/watch doesn't work in zones)
    selectedSiteName() {
        return state.selectedSite ? state.selectedSite.Name : null;
    }
};

// actions
const actions = {
    async fetchPublisher({commit}) {
        state.loadingPublisher = true;
        let {data} = await ServiceRepository.getPublisher()
        if (data.Status) {
            commit('setPublisher', {data: data.publisher});
        }
        state.loadingPublisher = false;
    },
    async fetchSites({state, commit}, payload = false) { //payload = isVideo -> default false
        let reqs = [];
        state.loadingSites = true;
        if (state.publisher) {
            state.publisher.forEach((publ) => {
                reqs.push(ServiceRepository.getSites(publ.PublisherId, payload));
            });
            await axios.all(reqs).then(axios.spread((...responses) => {
                let sites = [];
                if (responses) {
                    responses.forEach((res) => {
                        if (typeof res.data !== "undefined" && typeof res.data.sites !== "undefined") {
                            sites = sites.concat(res.data.sites);
                        }
                    });
                }
                if (payload) {
                    commit('video/setSites', {data: sites}, {root: true});
                } else {
                    commit('setSites', {data: sites});
                }
                state.loadingSites = false;
            }))
        }
    },
    async fetchDetails({state, commit}, payload) { //SitetypeId
        if (state.loadingSitetype) {
            state.sitetypeCancelToken.cancel();
        }
        state.loadingSitetype = true;
        state.sitetypeCancelToken = axios.CancelToken.source();
        try {
            let {data} = await ServiceRepository.getDetails(payload ? payload : state.selectedType.SitetypeId, state.sitetypeCancelToken.token)
            if (data.Status) {
                commit('setSiteDetails', {data: data, copyType: true});
                state.loadingSitetype = false;
            }
        } catch (e) {
            state.loadingSitetype = false;
        }
    },
    async fetchSiteDetails({state, commit}, payload) { //SiteId
        if (state.loadingSite) {
            state.siteCancelToken.cancel('getTypesAndDetails cancel');
        }
        state.loadingSite = true;
        state.siteCancelToken = axios.CancelToken.source();
        try {
            let {data} = await ServiceRepository.getSiteDetails(payload ? payload : state.selectedSite.SiteId, state.siteCancelToken.token)
            if (data.Status) {
                commit('updateSelectedSite', {data: data.Site});
                commit('updateSelectedType', {data: data.Types.find(x => x.Type === 'desktop') || data.Types[0]})
                commit('setSiteDetails', {data: data, copyType: false});
                state.loadingSite = false;
            }
        } catch
            (e) {
            state.loadingSite = false;
        }
    }
    ,
    async fetchModuleDetails({commit}, payload) {
        let {data} = await ServiceRepository.getModuleDetails(
            state.selectedSite.PublisherId,
            state.selectedSite.SiteId,
            state.selectedType.SitetypeId,
            payload.module_id)
        if (data.Status) {
            commit('setModuleDetails', {
                data: data,
                ids: {
                    publisher_id: state.selectedSite.PublisherId,
                    site_id: state.selectedSite.SiteId,
                    type_id: state.selectedType.SitetypeId,
                    module_id: payload.module_id
                }
            });
        }
    },
    async siteStatus({state, commit, rootState}, payload) {
        let site_id = typeof payload !== "undefined" ? payload.siteId : (state.selectedSite ? state.selectedSite.SiteId : -1);
        let override = typeof payload !== "undefined" && typeof payload.override !== "undefined" ? payload.override : false;
        let type = typeof payload !== "undefined" && typeof payload.type !== "undefined" ? payload.type : false;
        let {data} = await ServiceRepository.siteStatus(site_id, override, type);
        if (data.Status) {
            let hasEditRights = typeof (rootState.route.meta) === "undefined" ||
                typeof (rootState.route.meta.editRights) === "undefined" ||
                rootState.route.meta.editRights.includes(data.User.Group);
            //rootState.route.meta.editRights.includes(rootState.users.role);

            let readOnly = !hasEditRights || (typeof data.Edit !== "undefined" && !data.Edit) ? 1 : 0;
            //check if User has rights to view this page
            if (rootState.readOnly !== readOnly) {
                commit('updateReadOnly', readOnly, {root: true})
            }
        }
        return data;
    },
    async createSitetype({commit, dispatch, rootState}, payload) {
        let {data} = await ServiceRepository.createSitetype(payload)
        if (data.Status) {
            if (rootState.route.name === 'settings') {
                commit('settings/setTypes', data.Types, {root: true});
            } else {
                updateSitetype(data, commit, dispatch, payload);
            }
        }
        return data;
    }
    ,
    async deleteSitetype({state}, payload) {
        let {data} = await ServiceRepository.deleteSitetype(payload);
        if (data.Status) {
            state.ignoreTypeUpdate = true;
            state.selectedType = data.Types.find(x => x.SitetypeId === data.Current.SitetypeId);
            state.siteDetails = data;
            state.sitetypeUpdate++;
        }
        return data;
    }
    ,
    async editDomain({state}, payload) {
        let {data} = await ServiceRepository.editDomain(payload);
        if (data.Status) {
            state.siteDetails.Domains = data.Domains;
        }
        return data;
    }
    ,
    async deleteDomain({state}, payload) {
        let {data} = await ServiceRepository.deleteDomain(payload);
        if (data.Status) {
            state.siteDetails.Domains = data.Domains;
        }
        return data;
    }
    ,
    async editURL({state}, payload) {
        let {data} = await ServiceRepository.editURL(payload);
        if (data.Status) {
            state.siteDetails.URLs = data.URLs;
        }
        return data;
    }
    ,
    async deleteURL({state}, payload) {
        let {data} = await ServiceRepository.deleteURL(payload);
        if (data.Status) {
            state.siteDetails.URLs = data.URLs;
        }
        return data;
    }
    ,
    async fetchIncludeDetails(context, payload = null) {
        let {data} = await ServiceRepository.openIncludeWindow(payload);
        return data;
    }
    ,
    async saveInclude({state}, payload) {
        let {data} = await ServiceRepository.saveInclude(payload);
        if (data.Status) {
            Vue.set(state.siteDetails, 'Include', data.Include);
        }
        return data;
    }
    ,
    async deleteInclude({state}, payload) {
        let {data} = await ServiceRepository.deleteInclude(payload);
        if (data.Status) {
            Vue.set(state.siteDetails, 'Include', data.Include);
        }
        return data;
    }
    ,
    async copySitetype({commit, dispatch}, payload) {
        let {data} = await ServiceRepository.copySitetype(payload);
        if (data.Status) {
            updateSitetype(data, commit, dispatch, payload);
        }
        return data;
    }
};

// mutations
const mutations = {
    setPublisher(state, {data}) {
        data.sort(sortByName);
        state.selectedPublisher = [];
        /*data.forEach((publ) => {
            state.selectedPublisher.push(publ);
        });*/
        state.publisher = data;
    },
    setSites(state, {data}) {
        state.sites = data;
    },
    setSiteDetails(state, {data, copyType}) {
        if (copyType) {
            data.Types = state.siteDetails.Types;
            data.Deployment = state.siteDetails.Deployment;
        }
        state.siteDetails = data;
    },
    setSelectedModule(state, data) {
        state.selectedModule = data;
    },
    setModuleDetails(state, {data, ids}) {
        for (let id in ids) {
            data[id] = ids[id];
        }
        state.moduleDetails = data;
    },
    updateSelectedPublisher(state, {data}) {
        if (data.length !== 0) {
            state.selectedSite = null;
            state.selectedType = null;
        }
        state.selectedPublisher = data;
    },
    updateSelectedSite(state, {data}) {
        Vue.set(state, 'selectedSite', data)
    },
    updateSelectedType(state, {data}) {
        Vue.set(state, 'selectedType', data)
    },
    updateModuleDetails(state, {data}) {
        state.moduleDetails = data;
    },
    updateHistory(state, data) {
        Vue.set(state.siteDetails, 'History', data);
    },
    removeSelectedPublisher(state, {data}) {
        const index = state.selectedPublisher.findIndex(x => x.PublisherId === data.PublisherId);
        if (index >= 0) state.selectedPublisher.splice(index, 1);
    },
    updateIgnoreSite(state, {data}) {
        state.ignoreSiteUpdate = data;
    },
    updateIgnoreType(state, {data}) {
        state.ignoreTypeUpdate = data;
    },
    updateDeviceTypes(state, payload) {
        state.device_types = payload;
    },
    updateActiveTab(state, payload) {
        if (state.activeTab !== null) {
            state.previousTab = state.activeTab;
        }
        state.activeTab = payload;
    },
};

function sortByName(a, b) {
    if (a.Name < b.Name) {
        return -1;
    }
    if (a.Name > b.Name) {
        return 1;
    }
    return 0;
}

function updateSitetype(data, commit, dispatch, payload) {
    let sitetype = data.Types.find(x => x.Name === payload.Name);
    state.siteDetails.Types = data.Types;
    state.ignoreTypeUpdate = true;
    commit('updateSelectedType', {data: sitetype});
    dispatch('fetchDetails', sitetype.SitetypeId).then(() => {
        state.sitetypeUpdate++;
    });
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}